<template>
  <div class="page_signingObjectives">
    <div class="topOperation">
      <div class="top-left">
        <ShowNavHead />
        <div class="screenInputs">
          <div class="screenInput">
            <div class="flname">模板类型</div>
            <el-select v-model="listQuery.TempType" placeholder="" size="small" clearable>
              <el-option value="用工协议"></el-option>
              <el-option value="证明文件"></el-option>
              <el-option value="其他"></el-option>
            </el-select>
          </div>
          <div class="screenInput">
            <div class="flname">模板名称</div>
            <el-select v-model="listQuery.tempName" size="small" placeholder="" clearable filterable>
              <el-option v-for="(item,index) in tempList" :key="index" :label="item.templateName" :value="item.templateName"></el-option>
            </el-select>
          </div>
          <!-- <div class="screenInput">
            <div class="flname">主体名称</div>
            <el-select v-model="listQuery.b" placeholder="" size="small" clearable>
              <el-option value="1"></el-option>
              <el-option value="2"></el-option>
            </el-select>
          </div> -->
          <div class="screenInput">
            <div class="flname">项目名称</div>
            <el-input v-model="listQuery.ProjectName" size="small" clearable></el-input>
          </div>
        </div>
      </div>
      <div class="top-right">
        <el-button v-if="showDropScreen == -1" v-preventReClick type="success" size="small" @click="searchHandle" style="margin-right: 15px;">搜索</el-button>
      </div>
    </div>
    <div class="main-con" v-loading="qrcodeLoading" element-loading-text="生成二维码中" element-loading-spinner="el-icon-loading">
      <div class="crumbs">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item>雇员</el-breadcrumb-item>
          <el-breadcrumb-item>电子签约</el-breadcrumb-item>
          <el-breadcrumb-item>模板认领</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="ftabs">
        <div style="margin-bottom: 10px;" class="flex">
          <el-button type="primary" size="small" @click="assignTemp" v-if="checkPermission(['assignTemplate_assign'],permissionLists)">&nbsp;认领模板</el-button>
          <div class="addNewTemp cp" @click="getSSQUrl" v-if="checkPermission(['assignTemplate_create'],permissionLists)">去创建新模板>></div>
        </div>
        <el-table :data="tableData" border class="doc_table" v-loading="loading">
          <el-table-column prop="ProjectName" label="项目名称" :show-overflow-tooltip="true" align="center" width="130px">
          </el-table-column>
          <el-table-column prop="TempName" label="模板名称" :show-overflow-tooltip="true" align="center" width="160px">
          </el-table-column>
          <el-table-column prop="TempType" label="模板类型" :show-overflow-tooltip="true" align="center" width="80px">
          </el-table-column>
          <el-table-column prop="TempDescript" label="模板描述" :show-overflow-tooltip="true" align="center" width="160px">
          </el-table-column>
          <el-table-column prop="TempId" label="模板编号" :show-overflow-tooltip="true" align="center" width="130px">
          </el-table-column>
          <el-table-column prop="CustomeName" label="签约二维码"  align="center" min-width="160">
            <template slot-scope={row}>
              <div class="flex aic" style="width: 100%;justify-content: center;">
                <img src="./../../assets/images/qrcode.png" class="qrcode_img02" />
                <div class="greenName cp" style="margin-left: 5px;" @click="getNewQRcode(row)" v-if="!row.QrcodeId || row.StrDeadStart=='0'">生成新码</div>
                <div class="greenName cp" style="margin-left: 5px;" @click="seeQRcode(row)" v-if="row.QrcodeId && row.StrDeadStart!='0'">查看二维码</div>
                <div class="greenName cp" v-if="row.QrcodeId && row.StrDeadStart!='0'" style="margin-left: 15px;" @click="stopUse(row)">停用</div>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="ContractSubject" label="二维码主体" :show-overflow-tooltip="true" align="center" width="160px">
          </el-table-column>
          <el-table-column prop="AvailableNum" label="二维码次数限制" align="center" min-width="120px">
            <template slot-scope={row}>
              <el-popover placement="top-start" width="450" trigger="click">
                <el-table :data="appTable" v-loading="gridloading" style="width:421px">
                  <el-table-column width="100" property="Name" label="姓名"></el-table-column>
                  <el-table-column width="110" property="PhoneNum" label="手机号"></el-table-column>
                  <el-table-column width="200" property="StrIdCard" label="身份证"></el-table-column>
                </el-table>
                <div class="block">
                  <el-pagination v-if="appTotal>0" @current-change="currentChange2" :current-page.sync="appQuery.pageNum" :page-size="Number(appQuery.pageSize)" layout="total,sizes,prev,pager, next, jumper" :total="appTotal"></el-pagination>
                </div>
                <span class="greenName cp" slot="reference" @click="getAppList(row)" v-show="row.AvailableNum" title="点击查看报名列表">{{row.AvailableNum}}</span>
              </el-popover>
            </template>
          </el-table-column>
          <el-table-column prop="QrcoddTime" label="二维码生成时间" :show-overflow-tooltip="true" align="center" width="150">
            <template slot-scope={row}>
              {{ row.QrcodeCreateTime ? row.QrcodeCreateTime : ''}}
            </template>
          </el-table-column>
          <el-table-column prop="QrcoddTime" label="二维码失效时间" :show-overflow-tooltip="true" align="center" width="150">
            <template slot-scope={row}>
              {{ row.QrcoddTime ? row.QrcoddTime=='2099/12/31 0:00:00' ? '永久有效' : row.QrcoddTime.substring(0, 10) : ''}}
            </template>
          </el-table-column>
          <el-table-column prop="CustomeName" label="操作" align="center" width="180px" fixed="right">
            <template slot-scope={row}>
              <span class="greenName cp" @click="downTemp(row)">下载模板</span>
              <el-popconfirm title="这是一段内容确定删除吗？" @confirm="del(row)">
                <span slot="reference" class="greenName cp" style="margin-left: 10px;">删除</span>
              </el-popconfirm>
            </template>
          </el-table-column>
        </el-table>
        <div class="block">
          <el-pagination v-if="totalCount>0" @current-change="currentChange" :current-page.sync="listQuery.pageNum" :page-size="Number(listQuery.pageSize)" @size-change="handleSizeChange" :page-sizes="[10,20, 50, 100, 200]" layout="total,sizes,prev,pager, next, jumper" :total="totalCount"></el-pagination>
        </div>
      </div>
    </div>

    <el-dialog title="认领模板" :visible.sync="showAssign" width="500px">
      <el-form :model="formData" :rules="assignRules" ref="assignForm" label-width="80px">
        <el-form-item label="项目名称" prop="ProjectName">
          <el-select v-model="formData.ProjectName" placeholder="" clearable filterable value-key="Projectid" @change="changePro" style="width: 380px;">
            <el-option v-for="(item,index) in proNameList" :key="index" :label="item.StrprojectName" :value="item"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="模板" prop="TempName">
          <el-select v-model="Temp" value-key="templateId" placeholder="" clearable filterable @change="changeTemp" multiple @clear="clearTemp" style="width: 380px;">
            <el-option v-for="(item,index) in tempList" :key="index" :label="item.templateName" :value="item"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="模板类型" prop="TempType">
          <el-select v-model="formData.TempType" placeholder="" clearable filterable style="width: 380px;">
            <el-option value="用工协议"></el-option>
            <el-option value="证明文件"></el-option>
            <el-option value="其他"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="模板描述">
          <el-input type="textarea" v-model="formData.TempDescript" :autosize="{ minRows: 3}"></el-input>
        </el-form-item>
        <el-form-item label="" prop="NeedAppro">
          <el-radio v-model="formData.NeedAppro" label="1">需要审批</el-radio>
          <el-radio v-model="formData.NeedAppro" label="0" disabled>不需要审批</el-radio>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showAssign = false" size="small">取消</el-button>
        <el-button type="primary" v-preventReClick size="small" @click="confirmAssign">确定</el-button>
      </span>
    </el-dialog>

    <el-dialog :visible.sync="showQRcode" width="531px">
      <div class="QRcodeCreateTime" v-if="QRcodeCreateTime">二维码生成时间：{{QRcodeCreateTime}}</div>
      <el-image style="width: 500px;height: 500px;" :src=" headPath + QRCodeSrc" alt=""></el-image>
      <!-- <span slot="footer" class="dialog-footer">
        <el-button @click="showQRcode = false" size="small">取消</el-button>
        <el-button type="primary" v-preventReClick size="small" @click="down(QRCodeSrc)">下载</el-button>
      </span> -->
    </el-dialog>

    <div class="qrForm">
      <el-dialog title="生成新二维码" :visible.sync="showGetQRcode" width="1060px">
        <el-form :model="formQR" :inline="true" :rules="qrRules" ref="formQR" label-width="130px">
          <el-form-item label="签约主体" prop="ContractSubject">
            <el-select v-model="formQR.ContractSubject" placeholder="" clearable filterable size="small" @change="changeLeg" style="width:200px">
              <el-option v-for="(item,index) in legList" :key="index" :value="item.enterpriseName"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="法人" prop="LegalPer">
            <el-input v-model="formQR.LegalPer" readonly style="width:200px" disabled size="small"></el-input>
          </el-form-item>
          <el-form-item label="注册地址" prop="RegisterAddress">
            <el-input v-model="formQR.RegisterAddress" readonly style="width:200px" disabled size="small"></el-input>
          </el-form-item>
          <el-form-item label="二维码可使用次数" prop="AvailableNum">
            <el-input type="number" v-model="formQR.AvailableNum" style="width:200px" size="small"></el-input>
          </el-form-item>
          <el-form-item label="二维码失效时间" prop="QrcoddTime">
            <div class="flex">
              <el-date-picker type="date" placeholder="" v-model="formQR.QrcoddTime" value-format="yyyy-MM-dd" style="width:200px" :disabled="longterm" size="small"></el-date-picker>
              <el-checkbox v-model="longterm" style="margin-left: 10px;">永久有效</el-checkbox>
            </div>
          </el-form-item>
          <!-- <el-form-item label="客户单位全称" prop="EmployUnit">
            <el-input v-model="formQR.EmployUnit" style="width:200px" size="small"></el-input>
          </el-form-item>
          <el-form-item label="工资发放日" prop="PayDay">
            <el-input v-model="formQR.PayDay" type="number" style="width:200px" size="small"></el-input>
          </el-form-item>
          <el-form-item label="工资采用标准" prop="WageScale">
            <el-select v-model="formQR.WageScale" placeholder="" clearable filterable style="width:200px" size="small">
              <el-option v-for="(item,index) in 3" :key="index" :value="item"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="固定月薪" v-if="formQR.WageScale==1" prop="MonthlyEarning">
            <el-input-number v-model="formQR.MonthlyEarning" :min="0.01" clearable size="small" @input="limitInput($event,'固定月薪','MonthlyEarning')" :precision="2"></el-input-number>
          </el-form-item>
          <el-form-item label="基本工资" v-if="formQR.WageScale==2" prop="BasePay">
            <el-input-number v-model="formQR.BasePay" :min="0.01" clearable size="small" @input="limitInput($event,'基本工资','BasePay')" :precision="2"></el-input-number>
          </el-form-item> -->
          <el-form-item label="合同/协议类型" prop="ProtocolType">
            <el-select v-model="formQR.ProtocolType" value-key="name" placeholder="" clearable filterable size="small" @change="changeCont" style="width:200px">
              <el-option v-for="(item,index) in contractList" :key="index" :label="item.name" :value="item"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="工作岗位（工种）" prop="JobName" v-if="contractType!=1 && contractType!=9 && contractType!=10 &&contractType">
            <el-input v-model="formQR.JobName" style="width:200px" size="small"></el-input>
          </el-form-item>

          <el-form-item label="工作地点（区域）" prop="WorkSite" v-if="contractType==5 || contractType==6">
            <el-input v-model="formQR.WorkSite" style="width:200px" size="small"></el-input>
          </el-form-item>

          <el-form-item label="学校全称" prop="SchoolName" v-if="contractType==3 || contractType==9">
            <el-input v-model="formQR.SchoolName" style="width:200px" size="small"></el-input>
          </el-form-item>

          <el-form-item label="学生专业" prop="StudentMajor" v-if="contractType==9">
            <el-input v-model="formQR.StudentMajor" style="width:200px" size="small"></el-input>
          </el-form-item>

          <!-- <el-form-item label="性别" prop="Gender" v-if="contractType==9">
            <el-select v-model="formQR.Gender" placeholder="" clearable filterable size="small" style="width:200px">
              <el-option value="男"></el-option>
              <el-option value="女"></el-option>
            </el-select>
          </el-form-item> -->

          <!-- <el-form-item label="银行卡号">
            <el-input v-model="formQR.Bankcard" style="width:200px" size="small"></el-input>
          </el-form-item>

          <el-form-item label="开户银行">
            <el-input v-model="formQR.DepositBank" style="width:200px" size="small"></el-input>
          </el-form-item> -->

          <el-form-item label="入职日期" prop="DtEntryBdate">
            <el-date-picker type="date" placeholder="" v-model="formQR.DtEntryBdate" value-format="yyyy-MM-dd" style="width:200px" size="small"></el-date-picker>
          </el-form-item>

          <el-form-item label="工作年月日" prop="WorkingYearMonthDay" v-if="contractType==8">
            <el-input v-model="formQR.WorkingYearMonthDay" style="width:200px" size="small"></el-input>
          </el-form-item>

          <el-form-item :label="contractType == 1 || contractType == 2 || contractType == 5 || contractType == 6 ? '合同起始时间' : '协议起始时间'" prop="ContractStartTime" v-if="contractType!=9 && contractType!=10 && contractType">
            <el-date-picker type="date" placeholder="" v-model="formQR.ContractStartTime" value-format="yyyy-MM-dd" style="width:200px" size="small"></el-date-picker>
          </el-form-item>
          <el-form-item :label="contractType == 1 || contractType == 2 || contractType == 5 || contractType == 6 ? '合同时长（年）' : '协议时长（年）'" v-if="contractType!=9 && contractType!=10 && contractType">
            <el-input type="number" v-model="ContractTime" @blur="getContractEndDate" style="width:200px" size="small" :disabled="!formQR.ContractStartTime"></el-input>
          </el-form-item>
          <el-form-item :label="contractType == 1 || contractType == 2 || contractType == 5 || contractType == 6 ? '合同结束时间 （可编辑更改）' : '协议结束时间 （可编辑更改）'" prop="ContractEndTime" v-if="contractType!=9 && contractType!=10 && contractType">
            <el-date-picker type="date" placeholder="" v-model="formQR.ContractEndTime" value-format="yyyy-MM-dd" style="width:200px" size="small"></el-date-picker>
          </el-form-item>
          <el-form-item label="试用期起始时间" prop="TrialPeriodStartTime" v-if="contractType == 1 ||contractType == 2 ||contractType == 5 ||contractType == 7">
            <el-date-picker type="date" placeholder="" v-model="formQR.TrialPeriodStartTime" value-format="yyyy-MM-dd" style="width:200px" size="small"></el-date-picker>
          </el-form-item>
          <el-form-item label="试用期时长（月）" prop="TrialMonth" v-if="contractType == 1 ||contractType == 2 ||contractType == 5 ||contractType == 7">
            <el-input type="number" v-model="formQR.TrialMonth" style="width:200px" size="small" :disabled="!formQR.TrialPeriodStartTime" @blur="getEndDate"></el-input>
          </el-form-item>
          <el-form-item label="试用期结束时间（可编辑更改）" prop="TrialPeriodEndTime" v-if="contractType == 1 ||contractType == 2 ||contractType == 5 ||contractType == 7">
            <el-date-picker type="date" placeholder="" v-model="formQR.TrialPeriodEndTime" value-format="yyyy-MM-dd" style="width:200px" size="small"></el-date-picker>
          </el-form-item>

          <el-form-item :label="contractType==8 ? '终止（解除）劳动合同时间' : '终止（解除）协议时间'" prop="TimeLaborContract" v-if="contractType==8 || contractType==9 || contractType==10">
            <el-date-picker type="date" placeholder="" v-model="formQR.TimeLaborContract" value-format="yyyy-MM-dd" style="width:200px" size="small"></el-date-picker>
          </el-form-item>

          <el-form-item :label="contractType==8 ? '终止（解除）劳动合同时间（员工联）' : '终止（解除）协议时间（员工联）'" prop="TimeLaborContractStaff" v-if="contractType==8 || contractType==9 || contractType==10">
            <el-date-picker type="date" placeholder="" v-model="formQR.TimeLaborContractStaff" value-format="yyyy-MM-dd" style="width:200px" size="small"></el-date-picker>
          </el-form-item>


        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="showGetQRcode = false" size="small">取消</el-button>
          <el-button type="primary" v-preventReClick size="small" @click="confirmGetNewCode">确定</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
  import xz from "../../common";
  import moment from 'moment';
  import checkPermission from '@/utils/permission' // 权限判断函数
  export default {
    data() {
      var validatetTime = (rule, value, callback) => {
        if (!this.formQR.QrcoddTime && !this.longterm) {
          callback(new Error("请选择二维码失效时间"));
        } else {
          callback();
        }
      };
      var validatetTemp = (rule, value, callback) => {
        if (this.isNull(this.Temp)) {
          callback(new Error("请选择模板"));
        } else {
          callback();
        }
      };
      return {
        tableHeight: 0,
        showDropScreen: -1, //筛选下拉框 
        totalCount: 0,
        tableData: [],
        loading: false,
        listQuery: {
          ProjectName: '',
          tempName: '',
          TempType: '',
          pageNum: 1,
          pageSize: 10
        },
        roletype: localStorage.loginRoletype,
        formData: {
          Id: '',
          ProjectId: '', //项目id
          ProjectName: '', //项目名称
          TempId: '', //模板Id
          TempName: '', //模板名称
          TempType: '', //模板类型
          TempDescript: '', //模板描述
          NeedAppro: '1'
        },
        tempList: [], //选择模板列表
        showAssign: false,
        proNameList: [], //项目列表
        assignRules: {
          ProjectName: {
            required: true,
            message: '请选择项目',
            trigger: 'change'
          },
          TempName: {
            required: true,
            validator: validatetTemp,
            trigger: 'change'
          },
          TempType: {
            required: true,
            message: '请选择模板类型',
            trigger: 'change'
          },
          NeedAppro: {
            required: true,
            message: '请选择是否需要审批',
            trigger: 'change'
          },
        },
        showGetQRcode: false, //生成新码弹窗
        formQR: {
          Id: '',
          size: '40', //二维码尺寸
          ObjName: '', //项目名称
          ContractSubject: '', //签约主体
          LegalPer: '', //法人
          RegisterAddress: '', //注册地址
          // EmployUnit: '', //客户单位全称
          // PayDay: '', //工资发放日
          // WageScale: '', //工资标准方式 1/2/3
          // BasePay: undefined, //基本工资
          // MonthlyEarning: undefined, //固定月薪
          AvailableNum: '', //二维码可使用次数
          QrcoddTime: '', //二维码失效时间
          DtEntryBdate: '', //入职日期
          ContractStartTime: '', //合同起始时间
          ContractEndTime: '', //合同结束时间
          TrialPeriodStartTime: '', //试用期起始时间
          TrialPeriodEndTime: '', //试用期结束时间
          TrialMonth: '', //试期月份
          ContractSubject: '', //签约主体
          TempId: '',
          StrDeadStart: 1, //1为可用0为停用
          JobName: '', //岗位
          WorkSite: '', //工作地点
          SchoolName: '', //学校
          WorkingYearMonthDay: '', //工作年月日
          TimeLaborContract: '', //终止（解除）劳动合同时间
          TimeLaborContractStaff: '', //终止（解除）劳动合同时间（员工联）
        },
        qrRules: {
          ContractSubject: {
            required: true,
            message: '请选择签约主体',
            trigger: 'change'
          },
          LegalPer: {
            required: true,
            message: '请选择法人',
            trigger: 'change'
          },
          RegisterAddress: {
            required: true,
            message: '请选择注册地址',
            trigger: 'change'
          },
          AvailableNum: {
            required: true,
            message: '请输入二维码可使用次数',
            trigger: 'blur'
          },
          QrcoddTime: {
            required: true,
            validator: validatetTime,
            trigger: 'change'
          },
          EmployUnit: {
            required: true,
            message: '请输入客户单位全称',
            trigger: 'blur'
          },
          PayDay: {
            required: true,
            message: '请输入工资发放日',
            trigger: 'change'
          },
          WageScale: {
            required: true,
            message: '请选择工资采用标准',
            trigger: 'change'
          },
          MonthlyEarning: {
            required: true,
            message: '请输入固定月薪',
            trigger: 'blur'
          },
          BasePay: {
            required: true,
            message: '请输入基本工资',
            trigger: 'blur'
          },
          DtEntryBdate: {
            required: true,
            message: '请选择入职日期',
            trigger: 'change'
          },
          ContractStartTime: {
            required: true,
            message: '请选择合同起始时间',
            trigger: 'change'
          },
          ContractEndTime: {
            required: true,
            message: '请选择合同结束时间',
            trigger: 'change'
          },
          TrialPeriodStartTime: {
            required: true,
            message: '请选择试用期起始时间',
            trigger: 'change'
          },
          TrialPeriodEndTime: {
            required: true,
            message: '请选择试用期结束时间',
            trigger: 'change'
          },
          TrialMonth: {
            required: true,
            message: '请输入试用期时长',
            trigger: 'blur'
          },
          ProtocolType: {
            required: true,
            message: '请选择合同/协议类型',
            trigger: 'change'
          },
          JobName: {
            required: true,
            message: '请输入工作岗位（工种）',
            trigger: 'blur'
          },
          SchoolName: {
            required: true,
            message: '学校全称',
            trigger: 'blur'
          },
          WorkSite: {
            required: true,
            message: '请输入工作地点（区域）',
            trigger: 'blur'
          },
          WorkingYearMonthDay: {
            required: true,
            message: '请输入工作年月日',
            trigger: 'change'
          },
          TimeLaborContract: {
            required: true,
            message: '请选择终止（解除）劳动合同/协议时间',
            trigger: 'change'
          },
          TimeLaborContractStaff: {
            required: true,
            message: '请选择终止（解除）劳动合同/协议时间（员工联）',
            trigger: 'change'
          },
          StudentMajor: {
            required: true,
            message: '请输入学生专业',
            trigger: 'blur'
          },
          Gender: {
            required: true,
            message: '请选择性别',
            trigger: 'change'
          },
        },
        longterm: false, //长期有效
        legList: [], //签约主体列表
        showQRcode: false, //二维码弹窗
        QRCodeSrc: '', //二维码路径
        headPath: this.$store.state.EMP.imgPath,
        qrcodeLoading: false,
        appQuery: {
          QrcodeId: '',
          pageNum: 1,
          pageSize: 10
        },
        appTable: [], //二维码报名列表
        appTotal: 0,
        gridloading: false,
        permissionLists: [],
        ContractTime: '', //合同时长
        Temp: '', //模板
        contractList: this.$store.state.EMP.contractList, //合同/协议列表
        contractType: '',//选择的合同/协议类型
        QRcodeCreateTime:'',//二维码创建时间
      };
    },
    created() {
      this.calHeight();
      this.getContractList();
      this.GetTempListEmployee1();
      this.getProList();
      this.getLegalSubjectList();
      this.getButtonPower();
      console.log(this.contractList)
    },
    methods: {
      checkPermission,
      // 获取按钮权限
      getButtonPower() {
        let that = this
        let butQuery = {
          path: '/assignTemplate',
          powerEnName: 'employee'
        }
        xz.getbtnPowerIdBypage(butQuery).then(res => {
          if (res.status == 'ok') {
            let resmsg = res.msg
            if (!this.isNull(resmsg)) {
              for (let index = 0; index < resmsg.length; index++) {
                let element = resmsg[index];
                that.permissionLists.push(element.Enname);
              }
              // console.log(that.permissionLists)
            } else {
              this.permissionLists = []
            }
          } else {
            this.$message.error('获取按钮权限出错')
            this.permissionLists = []
          }
        })
      },
      calHeight() {
        this.tableHeight = Number(document.body.clientHeight);
      },
      isNull(o) {
        // console.log('isnull',o)
        return (
          o == undefined ||
          o == "undefined" ||
          (o + "").indexOf("undefined") > -1 ||
          o == null ||
          o == "" ||
          o == "null" ||
          o == [] ||
          o == "NaN" ||
          o == '[{}]'
        );
      },
      searchHandle() {
        this.getContractList();
      },
      //获取模板列表
      getContractList() {
        xz.getContractList(this.listQuery, this.roletype).then(res => {
          if (res.status == 'ok') {
            this.tableData = res.data.data;
            this.totalCount = res.data.totalcount;
          } else {
            this.tableData = [];
            this.totalCount = 0;
            this.$message.error('获取模板列表失败')
          }
        })
      },
      currentChange(val) {
        this.listQuery.pageNum = Number(val);
        this.getContractList();
      },
      handleSizeChange(val) {
        console.log(`每页 ${val} 条`);
        this.listQuery.pageNum = 1;
        this.listQuery.pageSize = val;
        this.getContractList();
      },
      //去创建新模板
      getSSQUrl() {
        xz.getBestSingnSOSUrl('', this.roletype).then(res => {
          if (res.status == 'ok') {
            console.log(res)
            window.open(res.data, '_blank');
          } else {
            this.$message.error('系统出错')
          }
        })
      },
      //下载合同模板
      downTemp(row) {
        xz.getTempCombined(row.TempId, this.roletype).then(res => {
          if (res.status == 'ok') {
            console.log(res)
            let url = res.data.content;
            let base64 = url.toString()
            let byteCharacters = atob(
              base64.replace(/^data:image\/(png|jpeg|jpg);base64,/, "")
            )
            let byteNumbers = new Array(byteCharacters.length)
            for (let i = 0; i < byteCharacters.length; i++) {
              byteNumbers[i] = byteCharacters.charCodeAt(i)
            }
            let byteArray = new Uint8Array(byteNumbers)
            let blob = new Blob([byteArray], {
              type: `application/pdf`
            })
            let aLink = document.createElement("a")
            aLink.download = row.TempName + '.pdf' //这里写保存时的图片名称
            aLink.href = URL.createObjectURL(blob)
            aLink.click()
          } else {
            this.$message.error('系统出错')
          }
        })
      },
      //删除
      del(row) {
        xz.delComtractTemp(row.Id, this.roletype).then(res => {
          if (res.status == 'ok') {
            this.$message.success('删除成功！')
            this.getContractList()
          } else {
            this.$message.error('系统出错')
          }
        })
      },
      //上上签GET合同模板列表
      GetTempListEmployee1() {
        xz.GetTempListEmployee1('', this.roletype).then(res => {
          if (res.status == 'ok') {
            this.tempList = res.data
          } else {
            this.$message.error('系统出错')
          }
        })
      },
      getProList() {
        let data = {
          projectname: "", // 项目名称
          projectid: "", // 项目id
          custname: "", //客户名称
          strAchieveowner: "", // 业绩归属人
          strservuserid: "", // 客服
          strBusiStat: "", //项目状态
          strpartner2: "", //合伙人
          perpage: 100000000,
          currpage: 1,
          strorgancode: "",
          roletype: this.roletype,
        }
        xz.getProjectLists(data).then((res) => {
          if (res.status == "ok") {
            this.proNameList = res.msg;
          } else {
            this.proNameList = [];
          }
        });
      },
      //认领模板
      assignTemp() {
        this.formData = {
          Id: '',
          ProjectId: '', //项目id
          ProjectName: '', //项目名称
          TempId: '', //模板Id
          TempName: '', //模板名称
          TempType: '', //模板类型
          TempDescript: '',
          NeedAppro: '1'
        }
        this.showAssign = true;
      },
      //选择模板
      changeTemp(val) {
        // this.formData.TempId = val.templateId;
        // this.formData.TempName = val.templateName;
        console.log(val)
      },
      clearTemp() {
        this.Temp = '';
      },
      //选择项目
      changePro(val) {
        this.formData.ProjectId = val.Projectid;
        this.formData.ProjectName = val.StrprojectName;
      },
      //确认认领
      confirmAssign() {
        this.$refs.assignForm.validate((valid) => {
          if (valid) {
            console.log(this.Temp)
            this.Temp.forEach((element, index) => {
              if (index == 0) {
                this.formData.TempId = element.templateId;
                this.formData.TempName = element.templateName;
              } else {
                this.formData.TempId = this.formData.TempId + ',' + element.templateId;
                this.formData.TempName = this.formData.TempName + ',' + element.templateName;
              }
            });
            xz.updataContractTemp(this.formData, this.roletype).then(res => {
              if (res.status == 'ok') {
                this.$message.success('认领成功');
                this.getContractList()
              } else {
                this.$message.error('系统出错');
              }
              this.showAssign = false;
            })
          }
        })
      },
      //生成新码
      getNewQRcode(row) {
        this.formQR = {
          Id: '',
          size: '40', //二维码尺寸
          ObjName: '', //项目名称
          ContractSubject: '', //签约主体
          LegalPer: '', //法人
          RegisterAddress: '', //注册地址
          AvailableNum: '', //二维码可使用次数
          QrcoddTime: '', //二维码失效时间
          DtEntryBdate: '', //入职日期
          ContractStartTime: '', //合同起始时间
          ContractEndTime: '', //合同结束时间
          TrialPeriodStartTime: '', //试用期起始时间
          TrialPeriodEndTime: '', //试用期结束时间
          TrialMonth: '', //试期月份
          ContractSubject: '', //签约主体
          TempId: '',
          StrDeadStart: 1, //1为可用0为停用
          JobName: '', //岗位
          WorkSite: '', //工作地点
          SchoolName: '', //学校
          WorkingYearMonthDay: '', //工作年月日
          TimeLaborContract: '', //终止（解除）劳动合同时间
          TimeLaborContractStaff: '', //终止（解除）劳动合同时间（员工联）
        }
        this.contractType = '';
        this.longterm = false;
        this.formQR.TempId = row.Id;
        this.formQR.ObjName = row.ProjectName;
        this.showGetQRcode = true;
      },
      //取签约主体列表
      getLegalSubjectList() {
        xz.getLegalSubjectList('', this.roletype).then(res => {
          if (res.status == 'ok') {
            this.legList = res.data
          } else {
            this.$message.error('获取签约主体列表出错');
          }
        })
      },
      //生成新码
      confirmGetNewCode() {
        this.$refs["formQR"].validate((valid) => {
          if (valid) {
            this.qrcodeLoading = true;
            this.showGetQRcode = false;
            if (this.longterm) {
              this.formQR.QrcoddTime = '2999-12-31'
            }
            xz.generateEConQRCode(this.formQR, this.roletype).then(res => {
              if (res.status == 'ok') {
                this.QRcodeCreateTime = moment().format('YYYY-MM-DD  h:mm:ss')
                this.QRCodeSrc = res.data;
                this.showQRcode = true;
                this.qrcodeLoading = false;
                this.getContractList();
              } else {
                this.$message.error('生成二维码失败');
                this.qrcodeLoading = false;
              }
            })
          }
        })

      },
      //查看二维码
      seeQRcode(row) {
        this.QRcodeCreateTime = row.QrcodeCreateTime;
        this.QRCodeSrc = row.QrcodUrl;
        this.showQRcode = true;
      },
      down(url) {
        let d = url.replace("\"", "").replace("\"", "");
        var path = this.headPath + d;
        const aTag = document.createElement('a')
        aTag.href = path
        aTag.click();
      },
      //停止使用
      stopUse(row) {
        xz.qrCodeDeactivation(row.QrcodeId).then(res => {
          if (res.status == 'ok') {
            this.$message.success('停用成功！')
            this.getContractList();
          } else {
            this.$message.error('系统出错');
          }
        })
      },
      //获取二维码报名列表
      getAppList(row) {
        this.appTable = [];
        this.appTotal = 0;
        this.appQuery = {
          QrcodeId: row.QrcodeId,
          pageNum: 1,
          pageSize: 10
        }
        this.econQRCodeRegisList()
      },
      econQRCodeRegisList() {
        this.gridloading = true;
        xz.econQRCodeRegisList(this.appQuery, this.roletype).then(res => {
          if (res.status == 'ok') {
            this.appTable = res.data.tempList;
            this.appTotal = res.data.totalcount;
            this.gridloading = false;
          } else {
            this.appTable = [];
            this.appTotal = 0;
            this.gridloading = false;
          }
        })
      },
      currentChange2(val) {
        this.appQuery.pageNum = Number(val);
        this.econQRCodeRegisList();
      },
      //选择主体
      changeLeg(val) {
        if (val) {
          xz.getLegalSubjec(val).then(res => {
            if (res.status == 'ok') {
              this.$set(this.formQR, 'LegalPer', res.data.LegalPerson)
              this.$set(this.formQR, 'RegisterAddress', res.data.RegisteredAddress.indexOf('$$') > -1 ? res.data.RegisteredAddress.replace('$$', '') : res.data.RegisteredAddress)
            } else {
              this.$message.error('获取主体信息出错')
            }
          })
        } else {
          this.$set(this.formQR, 'LegalPer', '')
          this.$set(this.formQR, 'RegisterAddress', '')
        }
      },
      //限制input输入类型
      limitInput(val, type, item) {
        if (val >= 10000) {
          this.$message.warning(type + '不能超过1万');
          this.$nextTick(() => {
            this.formQR[item] = undefined
          })
        }
      },
      getEndDate() {
        if (this.formQR.TrialMonth > 0) {
          this.formQR.TrialPeriodEndTime = moment(this.formQR.TrialPeriodStartTime).add(this.formQR.TrialMonth, 'months').format('YYYY-MM-DD');
          this.formQR.TrialPeriodEndTime = moment(this.formQR.TrialPeriodEndTime).subtract(1, 'days').format('YYYY-MM-DD');
        } else {
          this.formQR.TrialPeriodEndTime = this.formQR.TrialPeriodStartTime
        }
      },
      getContractEndDate() {
        if (this.ContractTime >= 1) {
          this.formQR.ContractEndTime = moment(this.formQR.ContractStartTime).add(this.ContractTime, 'years').format('YYYY-MM-DD');
          this.formQR.ContractEndTime = moment(this.formQR.ContractEndTime).subtract(1, 'days').format('YYYY-MM-DD');
        }
      },
      //选择合同/协议
      changeCont(val) {
        console.log(val)
        this.formQR.ProtocolType = val.name;
        this.contractType = val.val;
      }
    }
  };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .ftabs {
    background: #fff;
    padding: 10px 16px 16px;
    width: 98%;
    margin-bottom: 16px;
  }

  .qrcode_img02 {
    width: 20px;
    height: 20px;
  }

  .addNewTemp {
    line-height: 32px;
    margin-left: 30px;
    color: #598DE7;
  }
  .QRcodeCreateTime{
    font-size: 18px;
    text-align: center;
  }
</style>
<style>
  .page_signingObjectives .el-table .ascending .sort-caret.ascending {
    border-bottom-color: #c0c4cc;
  }

  .page_signingObjectives .el-table .descending .sort-caret.descending {
    border-top-color: #c0c4cc;
  }

  .page_signingObjectives .th_input_label .el-form-item__label {
    width: 66px !important;
  }

  .page_signingObjectives .el-form-item__label {
    padding: 0 5px 0 0;
  }

  .page_signingObjectives .el-tabs {
    background-color: #fff;
    padding: 0 10px;
  }

  .page_signingObjectives .screenInputs .screenInput {
    margin: 0 0 10px 5px;
  }

  .page_signingObjectives .screenInputs .screenInput .el-select .el-input__inner,
  .page_signingObjectives .re_down_form.el-form--inline .el-form-item__content,
  .page_signingObjectives .re_down_form .el-select,
  .page_signingObjectives .re_down_form .el-form-item__content,
  .page_signingObjectives .screenInput .el-input {
    width: 200px !important;
  }

  .page_signingObjectives .doc_table .el-table__body td.el-table__cell {
    padding: 5px 0;
  }

  .page_signingObjectives .doc_table .el-table__body th.el-table__cell {
    padding: 8px 0;
  }

  .page_signingObjectives .qrForm .el-input-number__increase,
  .page_signingObjectives .qrForm .el-input-number__decrease {
    display: none;
  }

  .page_signingObjectives .qrForm .el-input-number .el-input__inner {
    padding-left: 15px;
    padding-right: 15px;
    text-align: left;
  }

  .page_signingObjectives .qrForm .el-input-number {
    width: 200px;
  }

  .page_signingObjectives .qrForm .el-input__icon {
    height: 32px;
  }

  .page_signingObjectives .qrForm .el-form-item {
    margin-bottom: 10px;
  }

  .page_signingObjectives .qrForm .el-form-item__error {
    top: 34px;
  }
</style>